/** What to tell the user about documents that have not uploaded yet. */
export function waitingToUploadCopy(count: number, online: boolean): string {
  const one = count === 1;
  const updates = one ? '1 update is' : `${count} updates are`;
  return online
    ? `${updates} waiting to upload. We'll keep trying automatically.`
    : `${updates} waiting to upload. ${one ? "It'll" : "They'll"} upload automatically when you're back online.`;
}

/** What to tell the user when a sync failed with documents still waiting to upload. */
export function couldNotUploadCopy(count: number): string {
  const one = count === 1;
  return `We couldn't upload ${one ? '1 update' : `${count} updates`} yet. ${one ? "It's" : "They're"} safe on this device and we'll keep trying.`;
}
